var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Layout",
    {
      attrs: {
        hasChangedData: true,
        openModalChangeCountry: _vm.isOpenModalChangeCountry
      },
      on: {
        "update:openModalChangeCountry": function($event) {
          _vm.isOpenModalChangeCountry = $event
        },
        "update:open-modal-change-country": function($event) {
          _vm.isOpenModalChangeCountry = $event
        },
        confirmChangeFlag: _vm.handleConfirmChangeFlag
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "ep__main_content pt-80 body-content",
          attrs: { "data-form-container": "" }
        },
        [
          _c("section", { staticClass: "content__frame frame-information" }, [
            _c(
              "div",
              { staticClass: "header-information d-flex" },
              [
                _c("EpPageTitle", { staticClass: "header-information-title" }, [
                  _vm._v("Online Banking PayNow")
                ])
              ],
              1
            ),
            _c("hr", { staticClass: "w-100 m-0" }),
            _c("div", { staticClass: "content-information" }, [
              _c(
                "div",
                { staticClass: "content-information-header" },
                [
                  _c(
                    "EpLabel",
                    { staticClass: "content-information-header-note" },
                    [
                      _c("strong", [_vm._v("Note:")]),
                      _vm._v(
                        " Please enter the following UEN, Total Amount, and Transaction UID as Payee Reference (13 digits only, no space or additional remarks) for the payment."
                      )
                    ]
                  )
                ],
                1
              ),
              _c("div", { staticClass: "row content-information-row" }, [
                _c("div", { staticClass: "content-information-first-column" }, [
                  _vm._v("ONE's UEN:")
                ]),
                _c("div", [
                  _c(
                    "span",
                    {
                      staticClass: "form__txtAmount",
                      attrs: { "data-testid": "uen" }
                    },
                    [_vm._v(_vm._s(_vm.UEN))]
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "col p-0 text-right" },
                  [
                    _c(
                      "EpButton",
                      {
                        staticClass: "copy-button",
                        class: { "copied-btn": _vm.copiedUEN },
                        attrs: {
                          "data-testid": "copy-uen-button",
                          variant: "outlined"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleCopyTxnInfo("copyUEN")
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.copiedUEN ? "Copied" : "Copy") + " "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row content-information-row" }, [
                _c("div", { staticClass: "content-information-first-column" }, [
                  _vm._v("Payee Reference:")
                ]),
                _c("div", [
                  _c(
                    "span",
                    {
                      staticClass: "form__txtAmount",
                      attrs: { "data-testid": "transactionUid" }
                    },
                    [_vm._v(_vm._s(_vm.transactionUid))]
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "col p-0 text-right" },
                  [
                    _c(
                      "EpButton",
                      {
                        staticClass: "copy-button",
                        class: { "copied-btn": _vm.copiedTxnUid },
                        attrs: {
                          "data-testid": "copy-txn-uid-button",
                          variant: "outlined"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleCopyTxnInfo("copyTxnUid")
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.copiedTxnUid ? "Copied" : "Copy") +
                            " "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row content-information-row" }, [
                _c("div", { staticClass: "content-information-first-column" }, [
                  _vm._v("Total Amount:")
                ]),
                _c("div", [
                  _c(
                    "span",
                    {
                      staticClass: "form__txtAmount",
                      attrs: { "data-testid": "totalAmount" }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.currencyCode + " " + _vm.formattedTotalAmount
                        )
                      )
                    ]
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "col p-0 text-right" },
                  [
                    _c(
                      "EpButton",
                      {
                        staticClass: "copy-button",
                        class: { "copied-btn": _vm.copiedTotalAmt },
                        attrs: {
                          "data-testid": "copy-total-amt-button",
                          variant: "outlined"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleCopyTxnInfo("copyTotalAmt")
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.copiedTotalAmt ? "Copied" : "Copy") +
                            " "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ]),
            _c(
              "div",
              { staticClass: "footer-information" },
              [
                _c(
                  "EpButton",
                  {
                    staticClass: "new-payment-button",
                    on: { click: _vm.handleNewPaymentButton }
                  },
                  [_vm._v("New Payment")]
                ),
                _c(
                  "EpButton",
                  {
                    staticClass: "home-page-button",
                    attrs: { variant: "outlined", color: "secondary" },
                    on: { click: _vm.handleHomepageButton }
                  },
                  [_vm._v(" Home Page ")]
                )
              ],
              1
            )
          ]),
          _c("input", {
            attrs: { type: "hidden" },
            domProps: { value: _vm.transactionUid }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }